var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultibookmarkfill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94277 2.03711H1.95805C1.69334 2.03711 1.43947 2.14219 1.25229 2.32923C1.06512 2.51627 0.959961 2.76996 0.959961 3.03447V16.0002L5.95041 13.48L10.9409 16.0002V3.03447C10.9409 2.76996 10.8357 2.51627 10.6485 2.32923C10.4614 2.14219 10.2075 2.03711 9.94277 2.03711Z",
    fill: "#450A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2244 12.3465V0.997697H4.24281H3.24512C3.24512 0.733091 3.35023 0.479323 3.53734 0.292219C3.72444 0.105114 3.97821 0 4.24281 0H12.2244C12.489 0 12.7428 0.105114 12.9299 0.292219C13.117 0.479323 13.2221 0.733091 13.2221 0.997697V13.9678L12.2244 12.3465Z",
    fill: "#450A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultibookmarkfill);
export default __webpack_public_path__ + "static/media/multibookmarkfill.83a372cedc4ebfd18ba29306f11c6546.svg";
export { ForwardRef as ReactComponent };